import { SwapOutlined } from '@ant-design/icons';
import { Card, Timeline, Typography } from 'antd';
import moment from 'moment';
import { Trans } from 'react-i18next';

import useAPIQuery from '../../api/useAPIQuery';
import { CandidateDetail, JobPostingDetail } from '../../types';
import styles from './ApplicantHistory.module.css';

interface ApplicantAdmissionSentTimelineProps {
  recruiterName: string;
  createdDate: string;
  candidateId: CandidateDetail['id'];
  opportunityTitle?: string;
  opportunityId?: JobPostingDetail['id'];
}

const ApplicantAdmissionSentTimeline = ({
  recruiterName,
  createdDate,
  candidateId,
  opportunityTitle,
  opportunityId,
}: ApplicantAdmissionSentTimelineProps) => {
  const recruitmentProcess = useAPIQuery(
    [
      '/recruitment-processes/',
      {
        params: {
          candidate: candidateId,
          job_posting: opportunityId,
        },
      },
    ],
    {
      enabled: !!opportunityId,
      select(data) {
        return data.count > 0 ? data.results[0] : null;
      },
    }
  );

  const sankhyaAdmission = useAPIQuery(
    [
      '/sankhya/sankhya-admissions/',
      {
        params: {
          recruitment_process: recruitmentProcess.data?.id,
        },
      },
    ],
    {
      enabled: !!recruitmentProcess.data?.id,
      select(data) {
        return data.count > 0 ? data.results[0] : null;
      },
    }
  );

  const vixtingAdmission = useAPIQuery(
    [
      '/vixting/vixting-admissions/',
      {
        params: {
          recruitment_process: recruitmentProcess.data?.id,
        },
      },
    ],
    {
      enabled: !!recruitmentProcess.data?.id,
      select(data) {
        return data.count > 0 ? data.results[0] : null;
      },
    }
  );

  const externalAdmissionId =
    sankhyaAdmission.data?.external_sankhya_admission_id ||
    vixtingAdmission.data?.external_vixting_admission_id;

  return (
    <Timeline.Item dot={<SwapOutlined className={styles.sucessColor} />}>
      <Card>
        <Typography.Text type="secondary">{moment(createdDate).format('LLL')}</Typography.Text>
        <br />
        <Typography.Text strong>
          {recruiterName} <Trans>enviou para Admissão</Trans>{' '}
        </Typography.Text>
        <Trans>o(a) candidato(a) na vaga</Trans>
        <Typography.Text strong> {opportunityTitle} </Typography.Text>
        <Trans>com data de admissão</Trans>{' '}
        <Typography.Text strong>
          {moment(recruitmentProcess.data?.admission_date).format('L')}
        </Typography.Text>{' '}
        <Trans>e Salário</Trans>
        <Typography.Text strong> {recruitmentProcess.data?.salary} </Typography.Text>
        {!!externalAdmissionId && (
          <>
            - <Trans>ID da requisição</Trans>: {externalAdmissionId}
          </>
        )}
      </Card>
    </Timeline.Item>
  );
};

export default ApplicantAdmissionSentTimeline;
